import { App } from './App';
import './styles.scss';

const exports = { App };
export default exports;
